import { useQueryClient } from '@tanstack/react-query'

import { useContactsServicePostV1IndividualsByIndividualIdContacts } from '../client/queries'
import { useContactsServiceGetV1IndividualsByIndividualIdContactsKey } from '../client/queries/common'

export const useCreateContact = () => {
  const queryClient = useQueryClient()

  return useContactsServicePostV1IndividualsByIndividualIdContacts({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useContactsServiceGetV1IndividualsByIndividualIdContactsKey],
      })
    },
  })
}
